// extracted by mini-css-extract-plugin
export default {"divi":"SearchBar_divi__VPz16","input":"SearchBar_input__bIy50","botonsito":"SearchBar_botonsito__k8gWZ"};